import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout, Row, Col, Card } from 'antd';
import SiteSurveyTemplateForm from '../site_survey_template_form/SiteSurveyTemplateForm';
import LogOnMountWithStandardEventProperties from '../log_on_mount_with_standard_event_properties/LogOnMountWithStandardEventProperties';
import { withUserType } from '../withUserType';

const { Content } = Layout;

const NewSiteSurveyTemplatePage: React.FC<any> = ({ history, userType }): React.ReactElement => {
	return (
		<Content>
			<LogOnMountWithStandardEventProperties
				eventType={`visited ${userType} new site survey template page`}
			/>
			{/*<ScrollToTopOnMount/>*/}
			{/*<BackTop/>*/}
			<Row style={{ margin: '0.5em -8px' }} gutter={16}>
				<Col span={24}>
					<Card>
						<div>
							<h5 style={{ marginBottom: 24 }}>New Site Survey Template</h5>
							<SiteSurveyTemplateForm
								formData={{}}
								onSuccess={(rec) =>
									history.push(`/${userType}/siteSurveys/templates/detail/${rec.id}`)
								}
							/>
						</div>
					</Card>
				</Col>
			</Row>
		</Content>
	);
};

const mapStateToProps = (state) => ({
	siteSurveyTemplates: state.site_survey_templates.detail,
});

export default withUserType(
	withRouter(connect(mapStateToProps)(NewSiteSurveyTemplatePage as any)) as any
);
